import type { NextIncomingMessage } from 'next/dist/server/request-meta';

/** Describes an error happening during an API call */
export class APIClientError extends Error {
    public message: string;
    public response: Response;
    public requestInfo: object;

    constructor(message: string, response?: Response, req?: NextIncomingMessage) {
        super(message);
        this.message = message;
        this.response = response;
        this.requestInfo = req
            ? {
                  correlationId: req.headers['correlation-id' as keyof typeof req.headers],
                  userAgent: req.headers['user-agent' as keyof typeof req.headers],
              }
            : {};
    }
}
